import Vue from "vue";
import VueRouter from "vue-router";
const Login = import(/* webpackChunkName: "about" */ "../views/Login.vue");
const Test = import(/* webpackChunkName: "about" */ "../views/Test.vue");
const To = import(/* webpackChunkName: "about" */ "../views/To.vue");
const Draft = import(/* webpackChunkName: "about" */ "../views/Draft.vue");
const Forward = import(/* webpackChunkName: "about" */ "../views/Forward.vue");
const SavemessageDraft = import(
  /* webpackChunkName: "about" */ "../views/SavemessageDraft.vue"
);
const ExportnoteDraft = import(
  /* webpackChunkName: "about" */ "../views/ExportnoteDraft.vue"
);
const Review = import(/* webpackChunkName: "about" */ "../views/Review.vue");
const Sign = import(/* webpackChunkName: "about" */ "../views/Sign.vue");
const Pass = import(/* webpackChunkName: "about" */ "../views/Pass.vue");
const EditSavemessage = import(
  /* webpackChunkName: "about" */ "../views/EditSavemessage.vue"
);
const EditExportnote = import(
  /* webpackChunkName: "about" */ "../views/EditExportnote.vue"
);
const Savemessage = import(
  /* webpackChunkName: "about" */ "../views/Savemessage.vue"
);
const ChangePassword = import(
  /* webpackChunkName: "about" */ "../views/ChangePassword.vue"
);
const AddNewUser = import(
  /* webpackChunkName: "about" */ "../views/AddNewUser.vue"
);
const EditUser = import(
  /* webpackChunkName: "about" */ "../views/EditUser.vue"
);
const Receivenote = import(
  /* webpackChunkName: "about" */ "../views/Receivenote.vue"
);
const AlreadyDone = import(
  /* webpackChunkName: "about" */ "../views/AlreadyDone.vue"
);
const Done = import(/* webpackChunkName: "about" */ "../views/Done.vue");
const InboundAll = import(
  /* webpackChunkName: "about" */ "../views/InboundAll.vue"
);
const Inbound = import(
  /* webpackChunkName: "about" */ "../views/InboundReport.vue"
);
const OutboundAll = import(
  /* webpackChunkName: "about" */ "../views/OutboundAll.vue"
);
const ReceivenoteDraft = import(
  /* webpackChunkName: "about" */ "../views/ReceivenoteDraft.vue"
);
const Exportnote = import(
  /* webpackChunkName: "about" */ "../views/Exportnote.vue"
);
const ExportnoteStamp = import(
  /* webpackChunkName: "about" */ "../views/ExportnoteStamp.vue"
);
const ExportnoteInternal = import(
  /* webpackChunkName: "about" */ "../views/ExportnoteInternal.vue"
);
const Worklist = import(
  /* webpackChunkName: "about" */ "../views/Worklist.vue"
);
const SetRoleSecretary = import(
  /* webpackChunkName: "about" */ "../views/SetRoleSecretary.vue"
);
const SysConfigDetail = import(
  /* webpackChunkName: "about" */ "../views/SysConfigDetail.vue"
);
const SysConfigMain = import(
  /* webpackChunkName: "about" */ "../views/SysConfigMain.vue"
);
const EditSysConfig = import(
  /* webpackChunkName: "about" */ "../views/EditSysConfig.vue"
);
const ReserveNumber = import(
  /* webpackChunkName: "about" */ "../views/Reserve.vue"
);
const ReserveHistory = import(
  /* webpackChunkName: "about" */ "../views/ReserveHistoryList.vue"
);
const Document = import(
  /* webpackChunkName: "about" */ "../views/Document.vue"
);
const ViewDocument = import(
  /* webpackChunkName: "about" */ "../views/ViewDocument.vue"
);
const WorkAssign = import(
  /* webpackChunkName: "about" */ "../views/WorkAssign.vue"
);
const WorkAssignForm = import(
  /* webpackChunkName: "about" */ "../views/WorkAssignForm.vue"
);
const EditSignature = import(
  /* webpackChunkName: "about" */ "../views/EditSignature.vue"
);
const Portal = import(/* webpackChunkName: "about" */ "../views/Portal.vue");
const EcmsInbound = import(
  /* webpackChunkName: "about" */ "../views/EcmsInbound.vue"
);
const EcmsOutbound = import(
  /* webpackChunkName: "about" */ "../views/EcmsOutbound.vue"
);
const Ecms = import(/* webpackChunkName: "about" */ "../views/Ecms.vue");
const Calendar = import(
  /* webpackChunkName: "about" */ "../views/WorkAssignCalendar.vue"
);
const Agency = import(/* webpackChunkName: "about" */ "../views/Agency.vue");
const EmailInbound = import(
  /* webpackChunkName: "about" */ "../views/EmailInbound.vue"
);
const EmailDraft = import(
  /* webpackChunkName: "about" */ "../views/EmailDraft.vue"
);
const EmailOutbound = import(
  /* webpackChunkName: "about" */ "../views/EmailOutbound.vue"
);
const EcmsEmailInbound = import(
  /* webpackChunkName: "about" */ "../views/EcmsEmailInbound.vue"
);
const EcmsEmailOutbound = import(
  /* webpackChunkName: "about" */ "../views/EcmsEmailOutbound.vue"
);
const WaitingSendEmail = import(
  /* webpackChunkName: "about" */ "../views/WaitingSendEmail.vue"
);
const WaitingEmail = import(
  /* webpackChunkName: "about" */ "../views/WaitingEmail.vue"
);
const OutboundReport = import(
  /* webpackChunkName: "about" */ "../views/OutboundReport.vue"
);
const resetPassword = import(
  /* webpackChunkName: "about" */ "../views/ResetPassword.vue"
);
const newPassword = import(
  /* webpackChunkName: "about" */ "../views/NewPassword.vue"
);

const Flow = import(
  /* webpackChunkName: "about" */ "../views/Flow.vue"
);


const NewTemplate =  import(/* webpackChunkName: "about" */ '../views/NewTemplate.vue')
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () => Login,
  },
  {
    path: "/document/:action/:docType/:docid",
    name: "view-only",
    component: () => import(/* webpackChunkName: "about" */ '../views/ViewOnly.vue'),
  },
  {
    path: "/flow/:worklistId",
    name: "flow",
    component: () => Flow,
  },
  {
    path: "/reset",
    name: "reset",
    component: () => resetPassword,
  },
  {
    path: "/newpassword/:tokenReset",
    name: "newpassword",
    component: () => newPassword,
  },
  {
    path: "/test",
    name: "test",
    component: () => Test,
  },

  {
    path: "/to",
    name: "to",
    component: () => To,
  },
  {
    path: "/inboundAll",
    name: "inboundAll",
    component: () => Inbound,
  },
  {
    path: "/draft",
    name: "draft",
    component: () => Draft,
  },
  {
    path: "/forward",
    name: "forward",
    component: () => Forward,
  },

  {
    path: "/savemessagedraft/:action/:id",
    name: "savemessagedraft",
    component: () => SavemessageDraft,
  },
  {
    path: '/newtemplate/:docTypeName/:action/:id?',
    name: 'newtemplate',
    component: () => NewTemplate
  },
  {
    path: "/viewDocument/:docType/:id",
    name: "viewDocument",
    component: () => ViewDocument,


},  {
    path: "/exportnotedraft/:action/:id",
    name: "exportnotedraft",
    component: () => ExportnoteDraft,
  },
  {
    path: "/review",
    name: "review",
    component: () => Review,
  },
  {
    path: "/sign",
    name: "sign",
    component: () => Sign,
  },
  {
    path: "/pass",
    name: "pass",
    component: () => Pass,
  },
  {
    path: "/editsavemessage",
    name: "editsavemessage",
    component: () => EditSavemessage,
  },
  {
    path: "/editexportnote",
    name: "editexportnote",
    component: () => EditExportnote,
  },
  {
    path: "/savemessage",
    name: "savemessage",
    component: () => Savemessage,
  },
  {
    path: "/changepassword",
    name: "changepassword",
    component: () => ChangePassword,
  },
  {
    path: "/addnewuser",
    name: "addnewuser",
    component: () => AddNewUser,
  },
  {
    path: "/edituser",
    name: "edituser",
    component: () => EditUser,
  },
  {
    path: "/receivenote",
    name: "receivenote",
    component: () => Receivenote,
  },
  {
    path: "/alreadydone",
    name: "alreadydone",
    component: () => AlreadyDone,
  },
  {
    path: "/done/:docType/:id",
    name: "done",
    component: () => Done,
  },
  {
    path: "/inbound",
    name: "inbound",
    component: () => InboundAll,
  },
  {
    path: "/outbound",
    name: "outbound",
    component: () => OutboundAll,
  },
  {
    path: "/outboundall",
    name: "outboundall",
    component: () => OutboundReport,
  },
  {
    path: "/receivenotedraft",
    name: "receivenotedraft",
    component: () => ReceivenoteDraft,
  },

  {
    path: "/exportnote/:docType/:action/:docId?",
    name: "exportnote",
    component: () => Exportnote,
  },
  {
    path: "/stamp",
    name: "stamp",
    component: () => ExportnoteStamp,
  },
  {
    path: "/internal",
    name: "internal",
    component: () => ExportnoteInternal,
  },
  {
    path: "/worklist",
    name: "worklist",
    component: () => Worklist,
  },
  {
    path: "/setrolesecretary",
    name: "setrolesecretary",
    component: () => SetRoleSecretary,
  },
  {
    path: "/sysconfigdetail",
    name: "sysconfigdetail",
    component: () => SysConfigDetail,
  },
  {
    path: "/sysconfigmain",
    name: "sysconfigmain",
    component: () => SysConfigMain,
  },
  {
    path: "/editsysconfig",
    name: "editsysconfig",
    component: () => EditSysConfig,
  },
  {
    path: "/reservenumber",
    name: "reservenumber",
    component: () => ReserveNumber,
  },
  {
    path: "/reservehistory",
    name: "reservehistory",
    component: () => ReserveHistory,
  },
  {
    path: "/document",
    name: "document",
    component: () => Document,
  },
  {
    path: "/workassign",
    name: "workassign",
    component: () => WorkAssign,
  },
  {
    path: "/workassignform",
    name: "workassignform",
    component: () => WorkAssignForm,
  },
  {
    path: "/editsignature",
    name: "editsignature",
    component: () => EditSignature,
  },
  {
    path: "/portal",
    name: "portal",
    component: () => Portal,
  },
  {
    path: "/workassigncalendar",
    name: "workassigncalendar",
    component: () => Calendar,
  },
  {
    path: "/ecmsinbound",
    name: "ecmsinbound",
    component: () => EcmsInbound,
  },
  {
    path: "/ecmsoutbound",
    name: "ecmsoutbound",
    component: () => EcmsOutbound,
  },
  {
    path: "/ecms",
    name: "ecms",
    component: () => Ecms,
  },
  {
    path: "/agency",
    name: "agency",
    component: () => Agency,
  },
  {
    path: "/emailinbound",
    name: "emailinbound",
    component: () => EmailInbound,
  },
  {
    path: "/emaildraft",
    name: "emaildraft",
    component: () => EmailDraft,
  },
  {
    path: "/emailoutbound",
    name: "emailoutbound",
    component: () => EmailOutbound,
  },
  {
    path: "/ecmsemailinbound",
    name: "ecmsemailinbound",
    component: () => EcmsEmailInbound,
  },
  {
    path: "/ecmsemailoutbound",
    name: "ecmsemailoutbound",
    component: () => EcmsEmailOutbound,
  },
  {
    path: "/waitingsendemail",
    name: "waitingsendemail",
    component: () => WaitingSendEmail,
  },
  {
    path: "/waitingemail",
    name: "waitingemail",
    component: () => WaitingEmail,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

export default router;
